<!-- <nav class="navbar navbar-light py-0" [ngClass]="user() ? 'navbar-expand-custom navbar-loggedin':'navbar-expand-sm navbar-loggedout'"> -->
<!-- FOR NEW NAVIGATION STYLE CLASS ADDED: nav-reset, nav-bg-dark -->
<nav class="navbar navbar-light py-0 navbar-expand-md nav-reset "
    [ngClass]="{
      'navbar-loggedin': user(),
      'navbar-loggedout': !user(),
      'nav-bg-active': scrollOffsetExceeded()
    }">
  <!-- FOR NEW NAVIGATION STYLE CLASS changed: container-fluid to container -->
  <div class="container">
    <a class="navbar-brand" [ngClass]="{'light-mode':!darkModeActive()}" routerLink="/" [attr.aria-label]="'Home'">
      @if (!brand?.logo_banner) {
        <multisite-website-logos [logo]="logo()"></multisite-website-logos>
      }
      @if (brand?.logo_banner) {
        <img [src]="getLogoFile('logo_banner') | imageUrl" height="60px" width="auto" [alt]="brand.name" class="logo-banner">
      }
      @if (brand?.logo_square) {
        <img [src]="getLogoFile('logo_square') | imageUrl" height="60px" width="auto" [alt]="brand.name" class="logo-square">
      }
    </a>
    <button
      class="navbar-toggler"
      type="button"
      (click)="navCollapsed = !navCollapsed"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
      >
      <i class="fas fa-bars"></i>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarNav" [collapse]="navCollapsed" [isAnimated]="true">
      <ul class="navbar-nav" *transloco="let t">
        @for (link of navLinks(); track link) {
<li class="nav-item" [ngClass]="{'hide' : 
          (!user() && link.condition == 'hideIfNoUser') ||
          (!user() && !guest() && link.condition == 'hideIfNoUserAndNoGuest') ||
          (!hasRole('Admin') && link.condition == 'hideIfNotAdmin') ||
          (!hasRole('Developer') && link.condition == 'hideIfNotDeveloper')
        }">
            <a class="nav-link" aria-current="page" [routerLink]="link.routerLinkValue"
            routerLinkActive="active">{{link.labelLanguageKey ? t(link.labelLanguageKey) : link.labelText}}</a>
          </li>
        }

        @if (user()) {
          <li class="nav-item d-md-none">
            <div class="profile-details" dropdown>
              <a class="nav-link dropdown-toggle" id="navbarUserDropdown" role="button" dropdownToggle
                (click)="false" aria-expanded="false" aria-controls="navbarUserDropdown-dropdown">
                <div class="user-details">
                  <div class="d-flex align-items-center gap-2">
                    <img class="user-profile-img" [src]="user() | userAvatar" alt="Profile image">
                    <p class="name h5 text-wrap">{{user()?.fname+' '+user()?.lname}}</p>
                  </div>
                  <!-- ICON DROPDOWN -->
                  <span class="icon">
                    <i class="fa-solid fa-angle-down"></i>
                  </span>
                  <!-- END OF ICON DROPDOWN -->
                </div>
              </a>
              <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                aria-labelledby="button-animated">
                @for (link of filteredAccountDropdownLinks(accountDropdownLinks, user()?.roles); track link) {
                  <li [ngClass]="{'dropdown-header' : link.isHeader}">
                    @if (link.isHeader) {
                      <p>{{t(link.labelTranslationKey)}}</p>
                    }
                    @if (link.isDivider) {
                      <hr class="dropdown-divider">
                    }
                    @if (!link.isDivider && !link.isHeader) {
                      <a class="dropdown-item large" [routerLink]="link.routerLinkArray" routerLinkActive="active" (click)="link.clickHandler ? handleClick(link.clickHandler) : true">
                        <span class="icon-holder">
                          <i [class]="link.iconClasses"></i>
                        </span>
                        <div>
                          <p>{{t(link.labelTranslationKey)}}</p>
                        </div>
                      </a>
                    }
                  </li>
                }
              </ul>
            </div>
          </li>
        }

        @if (hasRole('Admin')) {
          <li class="nav-item align-items-center">
            <div class="splitter"></div>
          </li>
        }

        <li class="nav-item languages dropdown">
          <span dropdown>
            @if (activeLanguageObject) {
              <a class="nav-link dropdown-toggle" id="navbarAlternativeDropdown" role="button"
                dropdownToggle (click)="false" [attr.aria-label]="activeLanguageObject.flag_class" aria-expanded="false"
                aria-controls="navbarAlternativeDropdown-dropdown">
                <img [src]="getFlagUrl(activeLanguageObject,'w_24,c_fill,ar_1:1,r_max/','.png')" [alt]="t(activeLanguageObject.name)" class="mr-1">
              </a>
            }
            <ul id="navbarAlternativeDropdown-dropdown" *dropdownMenu class="dropdown-menu" role="menu"
              aria-labelledby="navbarAlternativeDropdown">
              @for (availableLanguage of availableLanguages; track availableLanguage) {
                <li>
                  <a class="dropdown-item" (click)="setActiveLanguage(availableLanguage.languageKey)">
                    <img [src]="getFlagUrl(availableLanguage,'w_16,c_fill,ar_1:1,r_max/','.png')"
                      [alt]="t(availableLanguage.name)" class="mr-1">
                    {{t('languages.'+availableLanguage.languageKey)}}
                  </a>
                </li>
              }
            </ul>
          </span>
        </li>

        @if (user()) {
          <li multisiteNotificationBell></li>
        }

        <!-- DUPLCIATE CODE start -->
        @if (user()) {
          <li class="nav-item d-none d-md-block">
            <div class="profile-details" dropdown>
              <a class="nav-link dropdown-toggle" id="navbarUserAlternativeDropdown" role="button" dropdownToggle
                (click)="false" aria-expanded="false" aria-controls="navbarUserAlternativeDropdown-dropdown">
                <div class="user-details">
                  <div class="d-flex align-items-center gap-2">
                    <img class="user-profile-img" [src]="user() | userAvatar" alt="Profile image">
                    <!-- <p class="name h5 text-wrap">{{user()?.fname+' '+user()?.lname}}</p> -->
                  </div>
                  <!-- ICON DROPDOWN -->
                  <span class="icon light">
                    <i class="fa-solid fa-angle-down"></i>
                  </span>
                  <!-- END OF ICON DROPDOWN -->
                </div>
              </a>
              <ul id="dropdown-animated-alternative" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                aria-labelledby="button-animated">
                @for (link of filteredAccountDropdownLinks(accountDropdownLinks, user()?.roles); track link) {
                  <li [ngClass]="{'dropdown-header' : link.isHeader}">
                    @if (link.isHeader) {
                      <p>{{t(link.labelTranslationKey)}}</p>
                    }
                    @if (link.isDivider) {
                      <hr class="dropdown-divider">
                    }
                    @if (!link.isDivider && !link.isHeader) {
                      <a class="dropdown-item large" [routerLink]="link.routerLinkArray" routerLinkActive="active" (click)="link.clickHandler ? handleClick(link.clickHandler) : true">
                        <span class="icon-holder">
                          <i [class]="link.iconClasses"></i>
                        </span>
                        <div>
                          <p>{{t(link.labelTranslationKey)}}</p>
                        </div>
                      </a>
                    }
                  </li>
                }
              </ul>
            </div>
          </li>
        }
        <!-- DUPLCIATE CODE end -->

        @if (!user()) {
          <li class="nav-item">
            <button class="nav-link btn btn-link text-decoration-none" id="navbarLogging" role="button" [routerLink]="['/login']" routerLinkActive="active" [disabled]="loading()">
              <i class="fa-solid fa-right-from-bracket"></i><span class="nav-link-mobile pl-2">{{ t('common.log_in')}}</span>
            </button>
          </li>
        }
      </ul>
    </div>
  </div>
</nav>